import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import compact from 'lodash/compact';
import { injectIntl } from 'react-intl';
import sanitizeHtml from 'sanitize-html';

import Button from '../../Button';
import Popup from '../../common/Popup';
import ExpandableListItem from '../../ExpandableListItem';

import styles from './styles.styl';

function ConsentDetails({
  total,
  consent,
  onClose,
  onAccept,
  details = {},
  intl: { formatMessage },
}) {
  const { idx, name, content, version, consentType = {} } = { ...consent };

  return (
    <Popup onClose={onClose} title={details.title} opened={Boolean(consent)}>
      <ExpandableListItem
        locked
        header={{
          title: details.for,
          icon: 'icon-consent',
          subtitle: details.subtitle,
        }}
      >
        <div className={styles.consent}>
          <div className={styles.title}>
            <span className={styles.name}>{name}</span>
            <span>
              <span className={styles.idx}>{idx}</span>
              <span className={styles.total}>/{total}</span>
            </span>
          </div>

          <div className={styles.subtitle}>
            {compact([
              consentType.name,
              `${formatMessage({ id: 'common.version' })} ${version}`,
            ]).join(', ')}
          </div>

          <div
            className={styles.content}
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(content),
            }}
          />
        </div>

        <div className={cn('bsw2-1', styles.footer)}>
          <Button
            color="primary"
            className={styles.button}
            onClick={() => onAccept(consent)}
          >
            {formatMessage({ id: 'common.accept' })}
          </Button>
        </div>
      </ExpandableListItem>
    </Popup>
  );
}

ConsentDetails.propTypes = {
  intl: PropTypes.object,
  total: PropTypes.number,
  onClose: PropTypes.func,
  onAccept: PropTypes.func,
  consent: PropTypes.object,
  details: PropTypes.object,
};

export default compose(injectIntl)(ConsentDetails);



// WEBPACK FOOTER //
// ./src/components/Consents/ConsentDetails/index.jsx